import { z } from 'zod';
import { ErrorResponseSchema, SuccessMessageSchema } from '@/schemas/common/base';

/**
 * POST /api/listings/[id]/report request schema
 * Reports a listing for review
 */
export const ReportListingRequestSchema = z.object({
  /** Report type ID (can be number or string) */
  type: z.union([z.number().int().positive(), z.string()]),
  /** Optional reason/details for the report */
  reason: z.string().max(1000).optional(),
});

/**
 * POST /api/listings/[id]/report response schema
 * Returns success message on successful report submission
 */
export const ReportListingResponseSchema = z.discriminatedUnion('success', [
  SuccessMessageSchema,
  ErrorResponseSchema,
]);

export type ReportListingRequest = z.infer<typeof ReportListingRequestSchema>;
export type ReportListingResponse = z.infer<typeof ReportListingResponseSchema>;
